import { useCallback } from "react";

import { losPipelineApi } from "../../api/losPipelineApi";
import { dealsForTab, PIPELINE_TABS } from "../../constants/pipelineTabs";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { BOARD_LAYOUT_SCOPE } from "../../hooks/utils/useUserPreferences";
import PipelineTableScreen from "./PipelineTableScreen";

// Pre-Close tab. Per loan_and_auth_endpoints.md §3–§4 there is NO per-stage
// endpoint — this is a client-side slice of the shared
// /underwriting/underwriting_pipeline payload, filtered to the "Pre-Close"
// statuses (pipeline "Underwriting" + the pre-close milestones).
const PreClosePipelineScreen = () => {
  useDocumentTitle("Pre-Close Pipeline");
  const fetchData = useCallback(({ onSuccessFn, onFailFn, onErrorFn }) => {
    const onError = onFailFn || onErrorFn || (() => {});
    losPipelineApi
      .getUnderwritingPipeline()
      .then((deals) => onSuccessFn?.(dealsForTab(deals, "PRE_CLOSE")))
      .catch(onError);
  }, []);

  return (
    <PipelineTableScreen
      title="Pre-Close"
      storageKeyPrefix="pre-close-pipeline"
      // Saved views are shared with Post Close and stored on the user profile,
      // so they follow the user to another machine.
      layoutScope={BOARD_LAYOUT_SCOPE}
      syncLayoutsToProfile
      fetchData={fetchData}
      statusField="loanStatus"
      statusOptions={PIPELINE_TABS.PRE_CLOSE.statuses}
    />
  );
};

export default PreClosePipelineScreen;
